// const new_service_basis = window.gtaAiConfig.service_basis

 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
 let service_data=getEnv(tag).service_data

export default {
  /**
   *  查询代码模式的积木菜单
   */
   getCodeBlockList: `${new_service_basis}/ai/training/editor/getCodeBlockList`,
  /**
   *  根据积木id查询积木菜单详情
   */
   getCodeBlockInfoById: `${new_service_basis}/ai/training/editor/getCodeBlockInfoById`,
}
